import { ReactElement } from "react"
import { Link } from "react-router-dom"
import { twMerge } from "tailwind-merge"

type ItemLinkTagProps = {
	to?: string
	label: string
	id?: string | number
	isActive?: boolean
	containerClassName: string
	className: string
	activeClassName: string
	dataCy: string
}

export const ItemLinkTag = ({
	to = "",
	label = "",
	isActive,
	className,
	activeClassName,
	containerClassName,
	dataCy,
}: ItemLinkTagProps): ReactElement => {
	return (
		<div className={containerClassName}>
			<Link
				data-cy={dataCy}
				className={twMerge(className, isActive && activeClassName)}
				to={to}
			>
				{label}
			</Link>
		</div>
	)
}
